<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import settingsEditor from "../settingsEditor/settingsEditor";

const configEditorSettings = {
    editorDescription: { type: "INFO", text: "The accordionMenu component can be used to generate a list of menu items.  Menu Items have a title and a collapsible content area.  The content area of each menu item can contain one or more of: text/HTML blocks, any component." },
    DocumentationUrl: {
        type: "URL",
        url: "https://samaritan.atlassian.net/wiki/spaces/DEVELOPMEN/pages/399540502/accordionMenu",
        text: "Accordion Menu Documentation",
        column: 2
    },
    menuItems: {
        label: 'Menu Items',
        id: 'menuItems',
        type: 'ARRAY',
        helpText: 'List of items to be displayed in the accordion menu.',
        column: 3,
        itemConfig: {
            primaryKey: 'header',
            itemType: 'object',
            keys: {
                header: {
                    type: 'string',
                    id: 'header',
                    label: 'Header',
                    helpText: 'Text for the menu item header.'
                },
                contentItems: {
                    type: 'ARRAY',
                    id: 'contentItems',
                    label: 'Content Items',
                    helpText: 'List of components or HTML in the expanded area of menu item.',
                    itemConfig: {
                        primaryKey: 'cId',
                        itemType: 'object',
                        keys: {
                            cType: {
                                type: 'string',
                                id: 'cType',
                                label: 'Component Type',
                                helpText: 'Select the type of component to display in the expanded content area.'
                            },
                            cId: {
                                type: 'string',
                                id: 'cId',
                                label: 'Component ID',
                                helpText: 'Select the ID of the component you want to display in the expanded content area.'
                            }
                        },
                        newItem: {
                            cType: 'testComponent',
                            cId: 'testComponent'
                        },
                        permissions: {
                            canDelete: true,
                            canMove: true,
                            allowAddItem: true
                        }
                    }
                }
            },
            permissions: {
                canDelete: true,
                canMove: true,
                allowAddItem: true
            },
            newItem: {
                header: 'New Header',
                contentItems: []
            }
        }
    }
};
const accordionMenuConfig = {
    cId: "accordionMenu",
    // @Dima:TODO fix it so I don't have to use accordionMenu2 here, the template should pull from the core component code, even if the cId of the core component is not being used.
    // cId: "accordionMenu",
    cTemplate: `<div class="accordion-menu" v-if="iConfig">
        <ejs-accordion :items="formattedMenuItems" :ref="'accordionMenu_' + cId" :id="cId" expandMode="Single" :expanded-indices="expandedIndices" :expanding="onAccordionExpanding"></ejs-accordion>
        <div v-for="(item, index) in formattedMenuItems" :id="item.contentId" :key="index" style="display:none;">
                <div v-for="(content, contentIndex) in item.contentItems" :key="contentIndex">
                    <div v-show="index !== openedItem" style="text-align: center; padding: 10px; font-weight: bold;">loading...</div>
                    <div v-show="index === openedItem">
                        <div v-if="content.html" v-html="content.html"></div>
                        <component v-if="content.cType" :is="content.cType" :cId="content.cId"></component>
                    </div>
                </div>
            </div>
    </div>`,
    cType: "accordionMenu",
    cTitle: "Accordion Menu",
    controls: []
};

const accordionMenuCmp = {
    name: 'accordionMenu',
    editorSettings: configEditorSettings,
    dataTestIds: [
        {
            querySelector: '.e-acrdn-header',
            cData: 'iConfig.menuItems._index_.header',
            suffix: 'header'
        },
        {
            querySelector: '.e-acrdn-panel',
            cData: 'iConfig.menuItems._index_.header',
            suffix: 'content'
        }
    ],
    data() {
        return {
            loadedDisplayedTab: {},
            mappedPropData: {},
            iConfig: false,
            openedItem: undefined,
            cInstanceId: false,
            editorSettings: configEditorSettings
        };
    },
    computed: {
        defaultOpenedItem() {
            return 0;
        },
        expandedIndices() {
            return [this.defaultOpenedItem];
        },
        formattedMenuItems() {
            let output = [];
            if (!this.iConfig || !this.iConfig.menuItems) return output;
            let menuItems = this.iConfig.menuItems;
            let uid = this.uniqueStoreId || "";
            menuItems.forEach((item, index) => {
                let contentId = `${uid}_menu_item_${index}_${this.cInstanceId}`;
                let newItem = { content: '#' + contentId, contentId, ...item };
                output.push(newItem);
            });
            return output;
        }
    },
    methods: {
        async onLoad() {
            let config = await componentStore.getConfig(this.cId);
            let passedConfig = this.iConfig;
            let settings = {};
            if (passedConfig) {
                settings = {
                    ...config,
                    ...passedConfig
                };
            } else {
                settings = {
                    ...config
                };
            }
            const d = new Date();
            this.cInstanceId = d.getTime();
            this.iConfig = settings;
        },
        onAccordionExpanding(item) {
            if (item && typeof item.index !== 'undefined') {
                setTimeout(() => {
                    this.openedItem = item.index;
                }, 1000); // NOSONAR
            }
        }
    },
    components: {
        settingsEditor,
        "ejs-accordion": defineAsyncComponent(() => import('@common/syncfusion/accordion'))
    }
};

componentStore.initComponent(accordionMenuCmp, accordionMenuConfig);
export { accordionMenuConfig, accordionMenuCmp };
export default accordionMenuCmp;
</script>
<style>
.accordion-menu .e-accordion .e-acrdn-item .e-acrdn-panel .e-acrdn-content{
    padding: 5px;
}
</style>
